// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "seat__info-3LJC2";
var _4 = "price-uNYtg";
var _5 = "price__wrapper-3OnM7";
var _6 = "seat-2ESrl";
var _7 = "seat_extended-1lGft";
var _8 = "title-2JiL4";
export { _1 as "__esModule", _2 as "mobile", _3 as "seat__info", _4 as "price", _5 as "price__wrapper", _6 as "seat", _7 as "seat_extended", _8 as "title" }
export default { "__esModule": _1, "mobile": _2, "seat__info": _3, "price": _4, "price__wrapper": _5, "seat": _6, "seat_extended": _7, "title": _8 }
